import React from 'react';
import { Navigate } from 'react-router-dom';
import { useVacationModuleAccess } from '../../hooks/useVacationModuleAccess';
import { LoadingSpinner } from '@/components/LoadingSpinner';

interface VacationModuleGuardProps {
    children: React.ReactNode;
    redirectTo?: string;
}

export function VacationModuleGuard({ children, redirectTo = '/collaborators/directory' }: VacationModuleGuardProps) {
    const { canSeeModule, isLoading } = useVacationModuleAccess();

    if (isLoading) {
        return <LoadingSpinner />;
    }

    if (!canSeeModule) {
        return <Navigate to={redirectTo} replace />;
    }

    return <>{children}</>;
}

export default VacationModuleGuard;
